import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { ChangePasswordComponent } from '../../modules/modals/modals-sign-in/change-password/change-password.component';

@Component({
  selector: 'rnpl-change-password-page',
  templateUrl: './change-password-page.component.html',
  styleUrls: ['./change-password-page.component.scss']
})
export class ChangePasswordPageComponent implements OnInit, OnDestroy {

  constructor(
    private dialog: MatDialog,
    private titleService: Title,
    private translateService: TranslateService,
  ) { }

  ngOnInit() {
    this.translateService.get('TEAM.CHANGE_PASS')
      .subscribe((translated: string) => {
        this.titleService.setTitle(`Runple. ${translated}`);
      });

    this.dialog.open(ChangePasswordComponent, {
      disableClose: true,
      backdropClass: 'drop-sign-in',
      closeOnNavigation: false,
      panelClass: 'sign-in-modal'
    });
  }

  ngOnDestroy() {
    this.dialog.closeAll();
  }

}
